import type { Agent } from '../../types';
import { AgentRow } from './AgentRow';
import type { AgentGroup } from './agent-groups';
import styles from './ShellDrawer.module.css';

export interface AgentGroupListProps {
  readonly groups: readonly AgentGroup[];
  readonly byId: Readonly<Record<string, Agent | undefined>>;
  readonly selectedId: string | null | undefined;
  readonly onSelect: (agentId: string) => void;
}

/** The drawer's agent groups, each under its label when it has one (only
 *  custom agents do). Shared by the drawer's list and Browse all. */
export function AgentGroupList({
  groups,
  byId,
  selectedId,
  onSelect,
}: AgentGroupListProps) {
  return (
    <>
      {groups.map((group) => (
        <div
          key={group.key}
          role={group.label ? 'group' : undefined}
          aria-label={group.label}
        >
          {group.label ? (
            <div className={styles.sectionHeader}>{group.label}</div>
          ) : null}
          {group.ids.map((id) => {
            const agent = byId[id];
            if (!agent) return null;
            return (
              <AgentRow
                key={id}
                agent={agent}
                isSelected={selectedId === id}
                onSelect={() => onSelect(id)}
              />
            );
          })}
        </div>
      ))}
    </>
  );
}
